/* YouTube AI Automation — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('mt-visible');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach(function (el) {
      obs.observe(el);
    });

    /* Red de seguridad: si algo impidiera que el observador dispare,
       el contenido se muestra igualmente a los 2,5 segundos. */
    setTimeout(function () {
      els.forEach(function (el) {
        el.classList.add('mt-visible');
      });
    }, 2500);
  }

  /* ---------- Cifras que cuentan al entrar ---------- */
  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          obs.unobserve(el);
          var fin = parseInt(el.getAttribute('data-mt-contador'), 10);
          if (isNaN(fin) || fin <= 0) return;
          var dur = 1100;
          var t0 = null;
          el.textContent = '0';
          function paso(ts) {
            if (t0 === null) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = String(Math.round(eased * fin));
            if (p < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.5 }
    );

    els.forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ---------- Barra de compra fija en móvil ---------- */
  function initSticky() {
    var barra = document.querySelector('[data-mt-sticky]');
    if (!barra) return;

    var disparador = document.querySelector('[data-mt-sticky-desde]');
    var limite = 620;

    function actualiza() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var pasado;
      if (disparador) {
        pasado = disparador.getBoundingClientRect().bottom < 0;
      } else {
        pasado = y > limite;
      }
      barra.classList.toggle('mt-sticky--on', pasado);
    }

    var esperando = false;
    window.addEventListener(
      'scroll',
      function () {
        if (esperando) return;
        esperando = true;
        requestAnimationFrame(function () {
          actualiza();
          esperando = false;
        });
      },
      { passive: true }
    );
    actualiza();
  }

  /* ---------- Ampliar las paginas de la guia ---------- */
  function initLupa() {
    var caja = document.querySelector('[data-mt-lupa]');
    var botones = document.querySelectorAll('[data-mt-zoom]');
    if (!caja || !botones.length) return;

    var img = caja.querySelector('[data-mt-lupa-img]');
    var pie = caja.querySelector('[data-mt-lupa-pie]');
    var cerrar = caja.querySelector('[data-mt-lupa-cerrar]');
    var ultimo = null;

    function abre(btn) {
      img.src = btn.getAttribute('data-mt-zoom');
      img.alt = btn.querySelector('img') ? btn.querySelector('img').alt : '';
      pie.textContent = btn.getAttribute('data-mt-zoom-pie') || '';
      caja.hidden = false;
      document.body.style.overflow = 'hidden';
      ultimo = btn;
      if (cerrar) cerrar.focus();
    }

    function cierra() {
      caja.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
      if (ultimo) ultimo.focus();
    }

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () { abre(btn); });
    });
    if (cerrar) cerrar.addEventListener('click', cierra);
    caja.addEventListener('click', function (e) {
      if (e.target === caja || e.target.tagName === 'FIGURE') cierra();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !caja.hidden) cierra();
    });
  }

  /* ---------- Panel de menu en movil ---------- */
  function initPanel() {
    var panel = document.querySelector('[data-mt-panel]');
    var abrir = document.querySelector('[data-mt-panel-abrir]');
    if (!panel || !abrir) return;
    if (abrir.getAttribute('data-mt-listo') === '1') return;
    abrir.setAttribute('data-mt-listo', '1');

    /* El panel nace dentro de la cabecera, que es "sticky" y tiene su propio
       nivel de apilado. Si se queda ahi, la barra de compra fija se le pone
       por encima. Lo sacamos al final del <body> para que siempre mande el. */
    var previos = document.querySelectorAll('[data-mt-panel]');
    for (var v = 0; v < previos.length; v++) {
      if (previos[v] !== panel && previos[v].parentNode === document.body) {
        previos[v].parentNode.removeChild(previos[v]);
      }
    }
    if (panel.parentNode !== document.body) document.body.appendChild(panel);

    var enlaces = panel.querySelectorAll('a');
    var primero = panel.querySelector('.mt-panel__x');
    var abierto = false;

    function foco(dentro) {
      /* Mientras el panel esta abierto, lo de detras no debe recibir el foco. */
      var i;
      for (i = 0; i < enlaces.length; i++) enlaces[i].tabIndex = dentro ? 0 : -1;
      if (primero) primero.tabIndex = dentro ? 0 : -1;
    }

    function abre() {
      if (abierto) return;
      abierto = true;
      panel.hidden = false;
      /* Forzamos el calculo de estilos para que la transicion arranque desde la
         posicion cerrada. Con requestAnimationFrame no vale: el navegador lo
         congela cuando la pestana no esta a la vista y el panel se quedaba
         fuera de pantalla. */
      void panel.offsetWidth;
      panel.classList.add('mt-panel--on');
      abrir.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      foco(true);
      if (primero) primero.focus();
    }

    function cierra(devolverFoco) {
      if (!abierto) return;
      abierto = false;
      panel.classList.remove('mt-panel--on');
      abrir.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      foco(false);
      if (devolverFoco !== false) abrir.focus();
      if (reduce) {
        panel.hidden = true;
      } else {
        setTimeout(function () { if (!abierto) panel.hidden = true; }, 300);
      }
    }

    abrir.addEventListener('click', function () {
      if (abierto) cierra(); else abre();
    });

    var cierres = panel.querySelectorAll('[data-mt-panel-cerrar]');
    for (var c = 0; c < cierres.length; c++) {
      cierres[c].addEventListener('click', function () { cierra(); });
    }

    /* Al pulsar un enlace del panel se cierra solo: los anclas (#) no
       recargan la pagina y el panel se quedaria tapandolo todo. */
    for (var e = 0; e < enlaces.length; e++) {
      enlaces[e].addEventListener('click', function () { cierra(false); });
    }

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && abierto) cierra();
    });

    /* Si se gira el movil o se ensancha hasta escritorio, el boton desaparece:
       el panel no puede quedarse abierto sin forma de cerrarlo. */
    window.addEventListener('resize', function () {
      if (abierto && window.innerWidth > 860) cierra(false);
    });

    foco(false);
  }

  /* ---------- Arranque ---------- */
  function init() {
    initPanel();
    initReveal();
    initContadores();
    initSticky();
    initLupa();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
